<template>
    <div class="file-upload-wrapper">
        <widget-message :bus="bus"></widget-message>
        <file-drop-area :filesCount="filesCount" :isUploading="isUploading" :multiple="multiple" :bus="bus"></file-drop-area>
        <div v-if="getFromSession().length > 0"><a style="color:blue" href="#" @click.prevent="showSessionFiles">Show Previously Uploaded Files</a></div>
        <file-upload-list :files="filesUi" :sessionFiles="sessionFiles" :container="containerName" :folderPath="folderPath" :bus="bus"></file-upload-list>
    </div>
</template>

<script>
    import fileDropAreaComponent from './port-fileupload-drop-area.vue';
    import fileUiListComponent from './port-fileupload-file-list-wrapper.vue';
    import messageComponent from './port-fileupload-message.vue';
    import async from 'async';
    import * as Vue from 'vue';
    import mitt from 'mitt';

    export default {
        props: {
            putBlockPath: {
                default: "/Azure/PutBlobBlock",
                type: String
            },
            commitPath: {
                default: "/Azure/CommitBlobs",
                type: String
            },
            cdnPath: {
                default: "",
                type: String
            },
            containerName: {
                default: "",
                type: String
            },
            folderPath: {
                default: "",
                type: String
            },
            fileTypesAllowed: {
                default: "",
                type: String
            },
            fileChunkSize: {
                default: 1024, // bytes
                type: Number
            },
            maximumFileSizeAllowed: {
                default: 1024, // bytes
                type: Number
            },
            multiple: {
                default: true,
                type: Boolean
            }
        },

        data: function() {
            return {
                files: [],
                filesUi: [],
                sessionFiles: [],
                uploadInitiated: false,
                container: true,
                supportsFileOp: true,
                cancelRequested: false,
                bus: null
            }
        },

        created: function () {
            //this.bus = new Vue();
            this.bus = mitt();

            if (this.folderPath.length > 0 && !_.endsWith(this.folderPath, "/")) {
                this.folderPath += "/";
            }

            if (this.folderPath.length > 0 && !_.startsWith(this.folderPath, "/")) {
                this.folderPath = "/" + this.folderPath;
            }

            if (this.cdnPath.length > 0 && !_.endsWith(this.cdnPath, "/")) {
                this.cdnPath += "/";
            }
        },

        mounted: function() {

            this.bus.on("filesSelected", this.addFilesToList);

            this.bus.on("startUpload", this.startUpload);

            this.bus.on("cancelUpload", this.requestCancel);

            this.bus.on("fileRename", ({ oldName, newName }) => {
                this.renameFile(oldName, newName);
            });

            this.bus.on("fileRemove", this.removeFileFromListWithName);

            this.bus.on("removeAllFiles", this.removeAllFiles);

            if (!this.containerName) {
                this.container = false;
                this.bus.emit("messageUpdate", { error: true, text: "Container is not defined." });
            }

            if (!window.File || !window.Blob || !window.FormData) {
                this.supportsFileOp = false;
                this.bus.emit("messageUpdate", { error: true, text: "Browser not supported." });
                return;
            }
        },

        beforeUnmount: function() {
            this.bus.off("filesSelected", this.addFilesToList);

            this.bus.off("startUpload", this.startUpload);

            this.bus.off("cancelUpload", this.requestCancel);

            this.bus.off("fileRename", this.renameFile);

            this.bus.off("fileRemove", this.removeFileFromListWithName);

            this.bus.off("removeAllFiles", this.removeAllFiles);
        },

        computed: {
            filesCount: function() {
                return this.files.length;
            },

            isUploading: function() {
                var uploading = this.uploadInitiated &&
                    this.files.length > 0 &&
                    this.filesUi.map(function(file) { return !file.uploaded; }).length > 0;

                if (!uploading) {
                    this.uploadInitiated = false;
                }

                return uploading;
            },

            isCancelled: function () {
                return this.cancelRequested;
            }

        },

        methods: {
            showSessionFiles: function(e) {
                this.$nextTick(function() {
                    $(e.target).hide();
                    this.addToSessionFiles();
                });
            },

            addFilesToList: function(files) {
                if (files) {
                    var thisComponent = this;

                    $.each(files,
                        function(i, file) {
                            if (file) {
                                thisComponent.checkIfFileExists(file.name,
                                    function(result) {
                                        if (result) {
                                            var fileInfo = {
                                                file: { name: file.name, rawFile: file },
                                                fileUi: {
                                                    name: result.name,
                                                    link: "#",
                                                    uploaded: false,
                                                    progress: 0,
                                                    exists: result.exists,
                                                    isCancelled: false
                                                }
                                            }
                                            thisComponent.files.push(fileInfo.file);
                                            thisComponent.filesUi.push(fileInfo.fileUi);
                                            thisComponent.$emit("file-selected", fileInfo);
                                        }
                                    });
                            }
                        });
                }
            },

            checkIfFileExists: function (fileName, callback) {
                var bus = this.bus;
                var data = {
                    container: this.containerName,
                    path: this.folderPath,
                    name: fileName
                }
                $.ajax({
                    type: "POST",
                    url: "/Azure/BlobExists",
                    data: data,
                    beforeSend: function() {
                        bus.emit("messageUpdate", { error: false, text: "Checking if file exists..." })
                    },
                    success: function(result) {
                        if (callback) {
                            callback(result);
                        }
                        return result;
                    },
                    error: function(error) {
                        bus.emit("messageUpdate", { error: true, text: error.statusText });
                        return null;
                    },
                    complete: function() {
                        bus.emit("clearMessages")
                    }
                });
            },

            renameFile: function(oldName, newName) {
                var thisComponent = this;

                $.each(this.files,
                    function() {
                        if (this.name === oldName) {
                            this.name = newName;
                            return;
                        }
                    });

                $.each(this.filesUi,
                    function () {
                        // if this is called from an external source, update the name
                        if (this.name === oldName) {
                            this.name = newName;
                        }
                        if (this.name === newName) {
                            var file = this;
                            thisComponent.checkIfFileExists(newName,
                                function(result) {
                                    file.exists = result.exists;
                                });
                            return;
                        }
                    });
            },

            removeFileFromListWithIndex: function(index) {
                // due ot async nature of updating array, 
                //we need to update the array on next loop
                this.$nextTick(function() {
                    this.files.splice(index, 1);
                });
            },

            removeFileUiFromListWithIndex: function(index) {
                this.$nextTick(function() {
                    this.filesUi.splice(index, 1);
                });
            },

            removeFileFromListWithName: function(name) {
                var thisComponent = this;

                $.each(this.files,
                    function(i, file) {
                        if (file.name === name) {
                            thisComponent.removeFileFromListWithIndex(i);
                            return;
                        }
                    });

                $.each(this.filesUi,
                    function(i, fileUi) {
                        if (fileUi.name === name) {
                            thisComponent.removeFileUiFromListWithIndex(i);
                            return;
                        }
                    });
            },

            removeAllFiles: function(except) {
                if (except) {
                    this.files = [ except.file ];
                    this.filesUi = [ except.fileUi ];
                } else {
                    this.files = [];
                    this.filesUi = [];
                }
            },

            updateFileUi: function (fileUi, cdnPath) {
                fileUi.link =
                    cdnPath
                        ? cdnPath
                        : this.cdnPath + this.containerName + (this.folderPath ? this.folderPath : this.containerName ? "/" : "") + fileUi.name;
                fileUi.uploaded = true;

            },

            checkIfAllFilesUploaded: function() {
                this.$nextTick(function() {
                    this.isUploading = this.files.length > 0 &&
                        this.filesUi.map(function(file) { return !file.uploaded }).length > 0;
                });

            },

            updateProgress: function(name, progress) {
                async.eachOf(this.filesUi,
                    function(fileUi) {
                        if (fileUi.name === name) {
                            fileUi.progress = progress;
                            return;
                        }
                    });
            },

            addToSession: function(val) {
                var sessionItemKey = "upload-widget-files";

                if (window.sessionStorage) {
                    var sessionFiles = sessionStorage.getItem(sessionItemKey);

                    if (sessionFiles) {
                        var sessionFilesJson = JSON.parse(sessionFiles);
                        sessionFilesJson.push(val);
                        sessionStorage.setItem(sessionItemKey, JSON.stringify(sessionFilesJson));
                    } else {
                        sessionStorage.setItem(sessionItemKey, JSON.stringify([val]));
                    }
                } else {
                    this.bus.emit("messageUpdate",
                        { error: false, text: "Your browser doesn't support session storage." });
                }
            },

            getFromSession: function() {

                var sessionItemKey = "upload-widget-files";

                if (window.sessionStorage) {
                    var items = sessionStorage.getItem(sessionItemKey);

                    if (items) {
                        var itemsJson = JSON.parse(items);
                        if (Array.isArray(itemsJson)) {
                            return itemsJson;
                        }
                    }
                } else {
                    this.bus.emit("messageUpdate",
                        { error: false, text: "Your browser doesn't support session storage." });
                }

                return [];
            },

            addToSessionFiles: function() {
                var thisComponent = this;

                var files = this.getFromSession();

                $.each(files,
                    function(index, item) {
                        thisComponent.sessionFiles.push(item);
                    });
            },

            requestCancel: function() {
                this.cancelRequested = true;
            },

            cancelUpload: function(fileName) {
                this.uploadInitiated = false;

                async.eachOf(this.filesUi,
                    function(fileUi) {
                        if (fileUi.name === fileName) {
                            fileUi.isCancelled = true;
                            fileUi.uploaded = false;
                            fileUi.progress = 0;
                            return;
                        }
                    });
            },

            startUpload: function() {
                var bus = this.bus;

                this.uploadInitiated = true;

                var thisComponent = this;

                /*****************************************
                    * File Chunk Component CLass
                    ******************************************/

                var FileChunkComponents = function(option) {
                    this.opt = option ? option : { fileChunkSize: 1024 };

                    // File Information
                    this.file = {};
                    this.fileSize = 0; // bytes
                    this.fileName = "";
                    this.type = "";

                    // File Block Information
                    this.block = {
                        size: this.opt.fileChunkSize, // bytes
                        ids: "",
                        putBlocks: []
                    };

                    this.appendXhr = null;

                };
                FileChunkComponents.prototype.appendPutBlocks = function(blob, index, progress) {
                    var that = this;

                    // Ready FormData 
                    var formData = new FormData();
                    formData.append("container", thisComponent.containerName);
                    formData.append("path", thisComponent.folderPath);
                    formData.append("name", that.fileName);
                    formData.append("type", that.type);
                    formData.append("index", index);
                    formData.append("file", blob, that.fileName + "-" + index);

                    this.block.putBlocks.push(function(callback) {
                        // POST FormData to the Backend Service
                        that.appendXhr = $.ajax({
                            url: that.opt.putBlockPath,
                            type: "POST",
                            data: formData,
                            processData: false,
                            contentType: false,
                            success: function(result) {
                                thisComponent.updateProgress(that.fileName, progress);
                                callback(null, {});
                            },
                            error: function() {
                                bus.emit("messageUpload",
                                    {
                                        error: true,
                                        text: "Error uploading block for " + that.fileName
                                    });
                            }
                        });
                        if (thisComponent.cancelRequested) {
                            this.appendXhr.abort();
                            thisComponent.cancelUpload(that.fileName);
                        }
                    });
                };
                FileChunkComponents.prototype.commitBlocks = function() {
                    var that = this;
                    if (that.block.ids.endsWith(',')) {
                        that.block.ids = that.block.ids.substring(0, that.block.ids.length - 1);
                    }
                    var data = {
                        container: thisComponent.containerName,
                        path: thisComponent.folderPath,
                        name: that.fileName,
                        type: that.type,
                        list: that.block.ids.split(',')
                    };

                    $.post(that.opt.commitPath,
                        data,
                        function(result) {

                            // Remove from the files array
                            $.each(thisComponent.files,
                                function(index, file) {
                                    if (file.name === that.fileName) {
                                        thisComponent.removeFileFromListWithIndex(index);
                                        return;
                                    }
                                });

                            // Update the Ui
                            $.each(thisComponent.filesUi,
                                function(index, fileUi) {
                                    if (fileUi && fileUi.name === that.fileName) {
                                        thisComponent.updateFileUi(fileUi,
                                            result ? result.CdnPath : null);
                                        thisComponent.addToSession(fileUi);
                                        return;
                                    }
                                });

                        }
                    ).fail(function() {
                        bus.emit("messageUpdate",
                            { error: true, text: "Error committing blocks for " + that.fileName });
                    });
                };
                FileChunkComponents.prototype.cancelAppendBlocks = function() {
                    if (this.appendXhr && this.appendXhr !== null) {
                        this.appendXhr.abort();
                    }
                };
                FileChunkComponents.prototype.cancelCommitBlocks = function() {
                    if (this.commitXhr && this.commitXhr !== null) {
                        this.commitXhr.abort();
                    }
                };
                FileChunkComponents.prototype.cancel = function() {
                    this.cancelAppendBlocks();
                    this.cancelCommitBlocks();
                };

                /*****************************************
                    * End File Chunk Component CLass
                    ******************************************/

                thisComponent.uploadInitiated = true;
                thisComponent.cancelRequested = false;

                var length = thisComponent.files.length;

                var fileUploadCollections = [];

                // Iterate through each files, calculate the blocks and create a list to stage the blocks
                for (var i = 0; i < length; i++) {

                    var file = thisComponent.files[i];

                    //var fileObj = new FileChunkComponents(_options);
                    var fileObj = new FileChunkComponents({
                        putBlockPath: this.putBlockPath,
                        commitPath: this.commitPath,
                        cdnPath: this.cdnPath,
                        container: this.containerName,
                        folderPath: this.folderPath,
                        fileTypesAllowed: this.fileTypesAllowed,
                        fileChunkSize: this.fileChunkSize,
                        maximumFileSizeAllowed: this.maximumFileSizeAllowed
                    });

                    fileObj.file = file.rawFile;
                    fileObj.fileSize = file.rawFile.size;
                    fileObj.fileName = file.name;
                    fileObj.type = file.rawFile.type;

                    var offset = 0;
                    var index = 0;
                    var ids = ""; // string for now -- change to list later

                    // calculate the start and end byte index for each blocks(chunks)
                    while (offset < file.rawFile.size) {
                        var start = offset;
                        var end = Math.min(offset + fileObj.block.size, file.rawFile.size);

                        // slice the file based on the calculated block chunk
                        var blob = file.rawFile.slice(start, end);
                        // (remaining/filesize) * 100%
                        var progress = Math.round((end / file.rawFile.size) * 100);

                        // Add to the list to Stage the block
                        fileObj.appendPutBlocks(blob, index, progress);

                        ids += index + ",";

                        offset = end;

                        index++;

                    } // end while loop

                    fileObj.block.ids = ids;

                    fileUploadCollections.push(fileObj);

                } // end for loop

                // Finally Invoke the block function one by one
                // and commit the blocks once all chunks are uploaded
                async.each(fileUploadCollections,

                    // Iterate each of the upload collections
                    function(fileUploadCollection, callback) {

                        // In series - upload blocks
                        async.series(fileUploadCollection.block.putBlocks,

                            // Success PUTTING blocks -- this is executed after all putBlocks are executed
                            function(error, results) {
                                // Commit the blocks after all blocks are staged.
                                fileUploadCollection.commitBlocks();
                            }
                        ); // end series loop
                    },
                    // ALl errors are sent here -- from callback() function
                    function(err) {
                        bus.emit("messageUpdate", { error: true, text: err });
                    }
                ); // end each loop

            },
            eventBus: function () {
                return this.bus;
            }
        },

        components: {
            "file-drop-area": fileDropAreaComponent,
            "file-upload-list": fileUiListComponent,
            "widget-message": messageComponent
        }
    }
</script>

<style>

</style>